import { initializeApp } from "firebase/app"
//import { initializeAppCheck, ReCaptchaV3Provider } from "firebase/app-check"
import { getAnalytics, logEvent, setAnalyticsCollectionEnabled, type Analytics } from "firebase/analytics"

let analyticsInstance: Analytics | undefined = undefined

export default defineNuxtPlugin(nApp =>
{
	const nuxtApp = useNuxtApp()

	// Initialize Firebase
	const app = initializeApp( nApp.$config.public.firebase )

	/*
	App CHeck:

	initializeAppCheck(app,
	{
		provider: new ReCaptchaV3Provider(nuxtApp.$config.public.apis.recaptcha),
		isTokenAutoRefreshEnabled: true,
	})
	*/

	if( nuxtApp.$gdprCookie.value === 'accepted' )
	{
		initAnalytics()
	}

	const router = useRouter()

    router.afterEach((to, from) =>
	{
		const pathChanged = to.path !== from.path

		if( pathChanged && analyticsInstance )
		{
			logEvent(analyticsInstance, 'page_view', {
				page_location: window.location.href,
				page_path: to.fullPath,
				page_title: document.title,
			})
		}
	})

	function initAnalytics()
	{
		if( !analyticsInstance )
		{
			analyticsInstance = getAnalytics( app )
		}

		setAnalyticsCollectionEnabled( analyticsInstance, true )
	}

	function log( event: string, data: any )
	{
		if( analyticsInstance )
		{
			logEvent(analyticsInstance, event, {
				page_location: window.location.href,
				...data,
			})
		}
	}

	function cancelAnalytics()
	{
		if( analyticsInstance )
		{
			setAnalyticsCollectionEnabled( analyticsInstance, false )
		}
	}

	return {
		provide: {
			app,
			initAnalytics,
			cancelAnalytics,
			log,
		},
	}
})